<app-cards-basic title="{{ 'PERIODS.title' | translate:{ count: 1 } }}"
                 [loading]="isLoading">
  <mat-form-field class="w-100">
    <mat-label>{{ 'PERIODS.assign' | translate }}</mat-label>
    <input type="text"
           placeholder="{{ 'PERIODS.period_search' | translate }}"
           aria-label="Period"
           matInput
           [formControl]="periodControl"
           [matAutocomplete]="auto"
           #trigger="matAutocompleteTrigger" (focus)="trigger.openPanel()">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="assignPeriod($event.option.value)">
      <mat-option *ngFor="let period of filteredPeriods | async" [value]="period">
        {{ period.translations['en'].title }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  @if (productData?.periods?.length) {
    <mat-chip-set aria-label="Benchmark selection">
      @for (period of productData.periods; track period) {
        <mat-chip-row (removed)="unassignPeriod(period)">
          {{ period.translations['en'].title }}
          <button matChipRemove [attr.aria-label]="'remove ' + period.translations['en'].title">
            <mat-icon>
              <span class="material-symbols-outlined" (click)="unassignPeriod(period)">close</span>
            </mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-set>
  }
</app-cards-basic>


@if (productData?.periods?.length && pageList.length) {
  <app-cards-basic title="{{ 'PERIODS.activate_on_page' | translate }}">
    @for (period of productData.periods; track period) {
      <h3 class="pt-4">{{ period.translations[currentLanguage].title }}</h3>
      <mat-nav-list>
        @for (page of pageList; track page) {
          <div mat-list-item>
            <mat-checkbox
              [checked]="isPeriodAssignedToPage(page, period)"
              (change)="togglePeriodAssignment(page, period, $event.checked)">
            </mat-checkbox>
            <span matListItemTitle>{{ page.translations[currentLanguage].title }}</span>
          </div>
        }
      </mat-nav-list>
    }
  </app-cards-basic>
}
